import { useApolloClient } from '@apollo/client/react';

import { TasksDocument } from 'src/graphql/actions/tasks/tasks.query';
import { refetchAppProtections } from 'src/containers/Applications/Protections/api';

export const useRefetchTasks = () => {
  const client = useApolloClient();

  return () => {
    client.cache.evict({ fieldName: 'tasks' });
    client.cache.gc();
    client.refetchQueries({ include: [TasksDocument] });
    // Unread task counts are also shown per app and per protection
    refetchAppProtections();
  };
};
